<template>
	<div>
		<v-app-bar flat app class="" style="z-index: 99;">
			<v-btn id="btn-drawerNav" text small @click.stop="clickDrawer">
				<img width="20" src="/assets/icon/toggle-list.svg" style="opacity: 0.55;" v-if="isDrawer === 60">
				<img width="20" src="/assets/icon/toggle-icon.svg" style="opacity: 0.55;" v-else>
			</v-btn>
			<v-spacer></v-spacer>
			
			<template v-if="myProfile">
				<template v-if="Object.keys(myProfile).length > 0 && myProfile.network_type !== 'diamond' && myProfile.network_id !== ''">
					<v-btn title="Upgrade Kemitraan" color="primary" outlined class="mr-5 d-none d-sm-block" @click="gotoUpgrade"><v-icon dense class="mr-1">mdi-shield-account-outline</v-icon>Upgrade Kemitraan</v-btn>
					<v-btn title="Upgrade Kemitraan" small fab depressed color="primary" class="d-sm-none mr-2" @click="gotoUpgrade"><v-icon dense>mdi-shield-account-outline</v-icon></v-btn>
				</template>

				<template v-if="Object.keys(myProfile).length > 0 && myProfile.network_id === ''">
					<v-btn title="Aktivasi Akun" color="warning" outlined class="mr-5 d-none d-sm-block" @click="gotoActivation"><v-icon dense class="mr-1">mdi-account-reactivate-outline</v-icon>Aktivasi Akun</v-btn>
					<v-btn title="Aktivasi Akun" small fab depressed color="warning" class="d-sm-none mr-2" @click="gotoActivation"><v-icon dense>mdi-account-reactivate-outline</v-icon></v-btn>
				</template>
			</template>

			<v-menu open-on-hover offset-y v-if="myProfile">
				<template v-slot:activator="{ on, attrs }">
					<v-btn large text class="menu-btn pl-1 pr-0" v-bind="attrs" v-on="on">
						<div class="d-none d-md-block cl-grey text-right btn-user-name">
							<div class="text-capitalize">{{ myProfile.member_name }}</div>
							<div class="networkcode-info">{{ myProfile.network_code }}</div>
						</div>
						<div class="d-block d-md-none cl-grey text-right btn-user-name">
							<div class="text-capitalize">{{ myProfile.member_name | ellipsisText(10) }}</div>
							<div class="networkcode-info">{{ myProfile.network_code }}</div>
						</div>
						<div class="px-2">
							<v-img width="40" height="40" class="user-img rounded-pill" :src="(myProfile.member_image_url) ? myProfile.member_image_url : '/assets/image/profile-pict.png'"></v-img>
						</div>
						<v-icon color="grey darken-1">mdi-chevron-down</v-icon>
					</v-btn>
				</template>
				<v-list>
					<router-link class="text-deco" :to="{ name: 'profile'}">
						<v-list-item link>
							<v-icon small class="pr-3">mdi-account</v-icon>
							<v-list-item-content>
								<v-list-item-title>
									<span class="font-size-11">Profile</span>
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</router-link>
					<router-link class="text-deco" :to="{ name: 'change-password'}">
						<v-list-item link>
							<v-icon small class="pr-3">mdi-key-variant</v-icon>
							<v-list-item-content>
								<v-list-item-title>
									<span class="font-size-11">Ubah Password</span>
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</router-link>
					<v-list-item link @click.native="onLogout">
						<v-icon small class="pr-3 red--text darken-3">mdi-exit-to-app</v-icon>
						<v-list-item-content>
							<v-list-item-title>
								<span class="font-size-11 font-weight-bold red--text darken-3">Logout</span>
							</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</v-list>
			</v-menu>
		</v-app-bar>
	</div>
</template>

<script>
// import { createNamespacedHelpers } from 'vuex';
// const { mapActions, mapState } = createNamespacedHelpers('auth');
import { mapState, mapActions } from 'vuex'

export default {
	data() {
		return {
			isActiveMember: false
		}
	},
	props: ['isDrawer'],
	computed: {
		...mapState('auth', ['userData']),
		...mapState('profile', ['myProfile']),
	},
	watch: {
    // eslint-disable-next-line no-unused-vars
    async $route(to, from) {
			const authData = await localStorage.getItem('mlmcore-vo-auth-data');
			const data = await JSON.parse(authData)

			await this.checkMemberActivation(data)

			if (this.isActiveMember) {
				await this.getProfileMitra()
			} else {
				await this.getProfilePramitra()
			}
    }
  },
	methods: {
		...mapActions('auth', ['logout']),
		...mapActions('profile', ['getProfile', 'getProfileMitra', 'getProfilePramitra']),
		
		clickDrawer() {
			this.$emit('childToParent')
		},
		onLogout() {
			this.logout().then( () => {
				this.$router.push({ name: 'login' })
			})
		},

		gotoUpgrade() {
			this.$router.push({name: 'upgrade-kemitraan'})
		},

		gotoActivation() {
			this.$router.push({name: 'aktivasi'})
		},

		async checkMemberActivation(data) {
			if (data.bin_network_id === "0" || data.bin_network_id === 0) this.isActiveMember = false
			else this.isActiveMember = true
		}
	},
	async mounted() {
		const authData = await localStorage.getItem('mlmcore-vo-auth-data');
		const data = await JSON.parse(authData)

		await this.checkMemberActivation(data)

		if (this.isActiveMember) {
			await this.getProfileMitra()
		} else {
			await this.getProfilePramitra()
		}
	}
};
</script>
